import * as React from 'react';
import { Col, Row } from '@cian/ui-kit';
import { IReviewSectionSchema } from '../../../../repositories/newbuilding-card/entities/reviews/ReviewSectionSchema';
import { IReviewWebSchema } from '../../../../repositories/newbuilding-card/entities/reviews/ReviewWebSchema';
import { Link } from '../../../Link';
import { ReviewAnswers } from '../../../ReviewAnswers';
import { ReviewAuthor } from '../../../ReviewAuthor';
import { ReviewComment } from '../../../ReviewComment';
import { ReviewItem } from '../../../ReviewItem';
import { ReviewLabels } from '../../../ReviewLabels';
import { ReviewsSections } from '../../../ReviewsSections';
import * as style from './ManyReviewsTeaser.css';
import { ReviewsFooter } from './ReviewsFooter';
import { ReviewsTitle } from './ReviewsTitle';
import { ReviewsReactionsContainer } from '../../../../containers/ReviewsReactionsContainer';

const SINGLE_REVIEW_ITEM = 1;

export interface IManyReviewsTeaserProps {
  fullUrl: string;
  name: string;
  rating: number;
  reviewsCountText: string;
  sections: IReviewSectionSchema[];
  reviews: IReviewWebSchema[];
  showReviewsLinkClick: () => void;
  readReviewLinkClick: () => void;
  masterReview: React.ReactElement;
  isQuestionsFeatureEnabled: boolean;
  title: string;
}

export const ManyReviewsTeaser: React.FC<IManyReviewsTeaserProps> = ({
  fullUrl,
  name,
  reviewsCountText,
  rating,
  reviews,
  sections,
  showReviewsLinkClick,
  readReviewLinkClick,
  masterReview,
  isQuestionsFeatureEnabled,
  title,
}) => {
  const isSingleReview = reviews.length === SINGLE_REVIEW_ITEM;

  return (
    <>
      <ReviewsTitle
        fullUrl={fullUrl}
        reviewsCountText={reviewsCountText}
        rating={rating}
        name={name}
        title={title}
        isQuestionsFeatureEnabled={isQuestionsFeatureEnabled}
      />

      <div className={style['sections']}>
        <ul className={style['list']}>
          {sections.map(({ name, rating }) => (
            <li key={name} className={style['item']}>
              <ReviewsSections name={name} value={rating} />
            </li>
          ))}
        </ul>
      </div>

      {masterReview}

      <div className={style['reviews']}>
        <Row>
          {reviews.map(({ id, user, date, isLegacy, comment, rating, labels, like, hasAnswers, answersCountInt }) => (
            // @ts-ignore
            <Col key={id} l={isSingleReview ? 12 : 6} xs={12}>
              <ReviewItem
                author={
                  <ReviewAuthor
                    avatarUrl={user.avatarUrl}
                    type={user.type}
                    name={user.name}
                    date={date}
                    rating={rating}
                  />
                }
                comment={<ReviewComment isLegacy={isLegacy} comment={comment} />}
                readFullReviewLink={
                  <Link url={`${fullUrl}otzyvy/#${id}`} target="blank" onClick={readReviewLinkClick}>
                    Читать полностью
                  </Link>
                }
                label={labels[0] && !isSingleReview && <ReviewLabels labels={labels} />}
                answers={hasAnswers && <ReviewAnswers reviewId={id} fullUrl={fullUrl} answersCount={answersCountInt} />}
                reactions={<ReviewsReactionsContainer reviewId={id} reactions={like} />}
              />
            </Col>
          ))}
        </Row>
      </div>

      <ReviewsFooter
        fullUrl={fullUrl}
        reviewsCountText={reviewsCountText}
        showReviewsLinkClick={showReviewsLinkClick}
      />
    </>
  );
};
